import { render, staticRenderFns } from "./BookingDgNotice.vue?vue&type=template&id=36b058cd"
import script from "./BookingDgNotice.vue?vue&type=script&lang=js"
export * from "./BookingDgNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36b058cd')) {
      api.createRecord('36b058cd', component.options)
    } else {
      api.reload('36b058cd', component.options)
    }
    module.hot.accept("./BookingDgNotice.vue?vue&type=template&id=36b058cd", function () {
      api.rerender('36b058cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trans/BookingDgNotice.vue"
export default component.exports